import PropTypes from 'prop-types';
import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import FormControl from '../../../shared/components/Form/FormControl';
import Select from '../../../shared/components/Select';
import { GENDER_TYPES } from '../../../utils/constants';

const PreRegisteredUserFields = ({ formik, disabled }) => {
  const { t } = useTranslation();

  return (
    <>
      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.common.birthday')}
          </Form.Label>
          <FormControl
            type='date'
            name="dob"
            data-cy="dob"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.dob}
            disabled={disabled}
            error={Boolean(formik.touched.dob && formik.errors.dob)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.dob && formik.errors.dob}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.common.gender')}
          </Form.Label>
          <Select
            name="gender"
            data-cy="gender"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.gender}
            disabled={disabled}
            error={Boolean(formik.touched.gender && formik.errors.gender)}
            options={GENDER_TYPES.map(gender => ({ label: gender, value: gender }))} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.gender && formik.errors.gender}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            <i className="fab fa-instagram mr-2" />
            {t('influencers.pages.user_registration.instagram_handle')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.instagram_handle')}
            name="ig_handle"
            data-cy="ig_handle"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.ig_handle}
            disabled={disabled}
            error={Boolean(formik.touched.ig_handle && formik.errors.ig_handle)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.ig_handle && formik.errors.ig_handle}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            <i className="fab fa-tiktok mr-2" />
            {t('influencers.pages.user_registration.tiktok_handle')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.tiktok_handle')}
            name="tt_handle"
            data-cy="tt_handle"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.tt_handle}
            disabled={disabled}
            error={Boolean(formik.touched.tt_handle && formik.errors.tt_handle)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.tt_handle && formik.errors.tt_handle}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            <i className="fab fa-youtube mr-2" />
            {t('influencers.pages.user_registration.youtube_handle')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.youtube_handle')}
            name="yt_handle"
            data-cy="yt_handle"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.yt_handle}
            disabled={disabled}
            error={Boolean(formik.touched.yt_handle && formik.errors.yt_handle)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.yt_handle && formik.errors.yt_handle}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            <i className="fab fa-linkedin mr-2" />
            {t('influencers.pages.user_registration.linkedin_handle')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.linkedin_handle')}
            name="link_handle"
            data-cy="link_handle"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.link_handle}
            disabled={disabled}
            error={Boolean(formik.touched.link_handle && formik.errors.link_handle)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.link_handle && formik.errors.link_handle}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12}>
        <h5 className="mt-3 mb-2">
          {t('influencers.pages.user_registration.mailing_address')}
        </h5>
      </Col>

      <Col xs={12}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.pages.user_registration.address_1')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.address_1')}
            name="address_1"
            data-cy="address_1"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.address_1}
            disabled={disabled}
            error={Boolean(formik.touched.address_1 && formik.errors.address_1)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.address_1 && formik.errors.address_1}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.pages.user_registration.address_2')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.address_2')}
            name="address_2"
            data-cy="address_2"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.address_2}
            disabled={disabled}
            error={Boolean(formik.touched.address_2 && formik.errors.address_2)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.address_2 && formik.errors.address_2}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.pages.user_registration.city')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.city')}
            name="city"
            data-cy="city"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.city}
            disabled={disabled}
            error={Boolean(formik.touched.city && formik.errors.city)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.city && formik.errors.city}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.pages.user_registration.state')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.state')}
            name="state"
            data-cy="state"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.state}
            disabled={disabled}
            error={Boolean(formik.touched.state && formik.errors.state)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.state && formik.errors.state}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.pages.user_registration.zip')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.zip')}
            name="zip"
            data-cy="zip"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.zip}
            disabled={disabled}
            error={Boolean(formik.touched.zip && formik.errors.zip)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.zip && formik.errors.zip}
          </Form.Text>
        </Form.Group>
      </Col>

      <Col xs={12} sm={6}>
        <Form.Group className='mb-3' >
          <Form.Label>
            {t('influencers.pages.user_registration.country')}
          </Form.Label>
          <FormControl
            type='text'
            placeholder={t('influencers.pages.user_registration.country')}
            name="country"
            data-cy="country"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.country}
            disabled={disabled}
            error={Boolean(formik.touched.country && formik.errors.country)} />
          <Form.Text className="text-muted danger-text">
            {formik.touched.country && formik.errors.country}
          </Form.Text>
        </Form.Group>
      </Col>
    </>
  );
};

PreRegisteredUserFields.propTypes = {
  formik: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

export default PreRegisteredUserFields;
